import type { ReactNode } from 'react';
import type { CardProps } from '@mui/material/Card';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import { Box, CircularProgress } from '@mui/material';

// ----------------------------------------------------------------------

type Props = CardProps & {
  title?: string;
  subheader?: string;
  loading?: boolean;
  renderChart?: () => ReactNode;
  renderLegend?: () => ReactNode;
};

export function ReportCard({
  title,
  subheader,
  renderChart,
  renderLegend,
  sx,
  loading,
  ...other
}: Props) {
  return (
    <Card sx={sx} {...other}>
      <CardHeader title={title} subheader={subheader} sx={{ mb: 3 }} />

      {renderLegend?.()}

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 240 }}>
          <CircularProgress />
        </Box>
      )}

      {!loading && renderChart?.()}
    </Card>
  );
}
